import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

/**
 * @deprecated Legacy icon.
 * */
function QuoteOpenedIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 22">
      <path fill="currentColor" d="M8.944 3.947V0C6.284.336 4.13 1.624 2.478 3.863.826 6.103 0 9.294 0 13.438v8.44h8.944v-9.154H4.367a14.676 14.676 0 00-.063-.651 2.576 2.576 0 01-.02-.357c0-1.176.195-2.366.587-3.57.784-2.435 2.142-3.835 4.073-4.199zm14.152 0V0c-3.192.392-5.487 1.897-6.887 4.514-1.4 2.618-2.1 5.592-2.1 8.924v8.44h8.987v-9.154h-4.577a2.866 2.866 0 01-.105-.546 6.065 6.065 0 01-.021-.504c0-1.932.399-3.64 1.196-5.123.798-1.484 1.967-2.352 3.507-2.604z"/>
    </SvgIcon>
  )
}
export default QuoteOpenedIcon
